<template>
  <div class="workshop-enroll">
    <div class="container">
      <div v-if="type === 'vip'" class="userInfo login">
        <div class="info-item">
          <div class="info-text" style='white-space:pre;'>姓 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    名:</div>
          <div class="info-detail">{{newUserInfo.personName}}</div>
        </div>
        <div class="info-item">
          <div class="info-text">手 机 号 码:</div>
          <div class="info-detail">{{newUserInfo.personMobile}}</div>
        </div>
        <div class="info-item">
          <div class="info-text">城 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    市:</div>
          <div class="info-detail">{{newUserInfo.cityName}}</div>
        </div>
        <div class="info-item">
          <div class="info-text">修理厂名称:</div>
          <div class="info-detail">{{newUserInfo.workshopName}}</div>
        </div>
      </div>
      <div v-else class="userInfo">
        <div class="info-item">
          <div class="info-text">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  名:</div>
          <div class="info-input">
            <input v-model.trim="newUserInfo.personName" />
          </div>
        </div>
        <div class="info-item">
          <div class="info-text">手 机 号 码:</div>
          <div class="info-input">
            <input v-model.trim="newUserInfo.personMobile" />
          </div>
        </div>
        <div class="info-item">
          <div class="info-text">城&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  市:</div>
          <div class="info-input">
            <input v-model.trim="newUserInfo.cityName" />
          </div>
        </div>
        <div class="info-item">
          <div class="info-text">修理厂名称:</div>
          <div class="info-input">
            <input v-model.trim="newUserInfo.workshopName" />
          </div>
        </div>
      </div>
    </div>
    <img v-if="type === 'vip'" class="workshop-enroll-bg" src="../../assets/images/activity/workshop/vipBg.png">
    <img v-else class="workshop-enroll-bg" src="../../assets/images/activity/workshop/noVipBg.png">
    <img class="immediatelyEnroll" src="../../assets/images/activity/workshop/immediatelyEnroll.png" @click="handleSubmit">

  </div>
</template>

<script>
import { Dialog } from 'vant'
// import { Notify } from 'vant'
import activityApi from '../../api/activity'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component
    // [Notify.Component.name]: Notify.Component
  },
  data () {
    return {
      type: '',
      newUserInfo: {
        personName: '',
        personMobile: '',
        workshopName: '',
        cityName: ''
      }
    }
  },

  computed: {
  },

  created () {
    // if (!this.clientInfo) {
    //   window.location.href = commonUtils.getExtraSite() + '/#/login'
    // }
    this.clientInfo = userUtils.getClientInfo()
    if (this.$route.query.type) {
      sessionStorage.setItem('enrollType', this.$route.query.type)
      this.type = this.$route.query.type
    } else {
      this.type = sessionStorage.getItem('enrollType')
    }
    this.fromSource = sessionStorage.getItem('fromSource')
    if (this.type === 'vip') {
      if (this.clientInfo !== null) {
        this.newUserInfo.personName = this.clientInfo.contactPerson
        this.newUserInfo.personMobile = this.clientInfo.contactMobile
        this.newUserInfo.workshopName = this.clientInfo.clientName
        this.newUserInfo.cityName = this.clientInfo.cityName
      } else {
        this.$router.push({
          name: 'login',
          params: { redirectUrl: 'activity-workshop-login', fromSource: this.$route.query.fromSource, type: this.$route.query.type }
        })
      }
    }
  },
  methods: {
    // 跳转
    toEnprll () {
      this.$router.push({ name: 'TradeApplyDetail' })
    },
    // 登录
    handleSubmit () {
      if (this.type === 'noVip') {
        if (!this.newUserInfo.personName) {
          this.$toast('请输入姓名')
          return
        }
        if (!this.newUserInfo.personMobile) {
          this.$toast.fail('请输入手机号码')
          return
        }
        if (this.newUserInfo.personMobile.length !== 11 || !(/^1[3|4|5|6|7|8|9]\d{9}$/.test(this.newUserInfo.personMobile))) {
          this.$toast.fail('请输入有效手机号码')
          return
        }
        if (!this.newUserInfo.cityName) {
          this.$toast.fail('请输入城市')
          return
        }
        if (!this.newUserInfo.workshopName) {
          this.$toast.fail('请输入修理厂名称')
          return
        }
      }
      this.$toast.loading({
        message: '正在报名...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      this.newUserInfo.fromSource = this.$route.query.fromSource
      activityApi.workshopLogin(this.newUserInfo)
        .then(response => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            // Notify({ type: 'success', message: '注册成功' })
            // this.$router.push({ name: 'activity-workshop-enorll', query: { fromSource: this.$route.query.fromSource } })
            Dialog.alert({ message: '报名成功' }).then(() => {
              // this.$router.push({ name: 'activity-workshop-enroll', query: { fromSource: this.$route.query.fromSource } })
              window.location.href = commonUtils.getExtraSite() + '/#/tab/home'
            })
          }
        })
        .catch(error => {
          this.$toast.clear()
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.workshop-enroll {
  position: relative;
}

.workshop-enroll .workshop-enroll-bg{
  width: 375px;
  height: auto;
}
.workshop-enroll .immediatelyEnroll{
  position: absolute;
  width: 160px;
  height: auto;
  top: 610px;
  left: 50%;
  margin-left: -80px;
}
.container {
  position: absolute;
  top: 350px;
  left: 60px;
}
.userInfo {
  width: 70vw;
}
.info-item {
  height: 35px;
  color: block;
  margin-bottom: 25px;
  display: flex;
  line-height: 35px;
}
.info-detail{
  margin-left: 20px;
  color: white;
}
.login{
  margin-right: 20px;
}
.info-text {
  width: 90px;
  height: 100%;
  color: white;
  text-align: justify;
}
.info-input {
  width: 65%;
  height: 100%;
  background-image: url("../../assets/images/activity/workshop/iptBg.png");
  background-size: 100% 100%;
}
.info-input input {
  padding-left: 5%;
  width: 98%;
  height: 100%;
  background: none;
  outline: none;
  border: 0px;
}
</style>
